import { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { FiSend } from 'react-icons/fi'

import Input from '../../shared/components/form/Input'
import { Context } from '../../context/UserContext'

import './auth.css'

function ForgotPassword() {
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)
    const { forgotPassword } = useContext(Context)

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        await forgotPassword(email)
        setSent(true)
        setLoading(false)
    }

    return (
        <div className="auth">
            <div className="auth-box panel">
                <p className="auth-eyebrow">Acesso à arena</p>
                <h1 className="auth-title">Esqueci minha senha</h1>
                <p className="auth-subtitle">Informe seu email — se a conta existir, enviamos um link de redefinição.</p>

                {!sent ? (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <Input
                            text="Email"
                            type="email"
                            name="email"
                            placeholder="seu@email.com"
                            handleOnChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />

                        <button className="btn-primary auth-submit" type="submit" disabled={loading}>
                            <FiSend size={16} />
                            {loading ? 'Enviando...' : 'Enviar link'}
                        </button>
                    </form>
                ) : (
                    <p className="auth-subtitle">Verifique seu email pra continuar.</p>
                )}

                <p className="auth-switch">
                    <Link to="/login">Voltar pro login</Link>
                </p>
            </div>
        </div>
    )
}

export default ForgotPassword
